import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import AddPaymentTermsModal from './AddPaymentTermsModal';
import ViewPaymentTermsModal from './ViewPaymentTermsModal';
import PaginationControls from '../Building/components/Renders/PaginationControls';
import SearchIcon from '@mui/icons-material/Search';
import API_BASE_URL from '../../../../Constants';
import { ColorRing } from 'react-loader-spinner';

import { DaysFromTypeMap } from "./paymentTermsConfig"

const PaymentTermsFields = [
    { key: 'actions', label: 'Actions' },
    { key: 'id', label: 'Payment ID' },
    { key: 'name', label: 'Payment Terms' },
    { key: 'daysFromType', label: 'Days From Type', map: DaysFromTypeMap },
    { key: 'daysFromDays', label: 'Days From Days' },
]

const PayementTermsList = () => {
    const [paymentTerms, setPayementTerms] = useState([]);
    const [filteredPaymentTerms, setFilteredPaymentTerms] = useState([]);


    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isViewOpen, setIsViewOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(false);

    const handleOpenCreateModal = () => setIsCreateOpen(true);

    const handleCloseCreateModal = () => setIsCreateOpen(false);

    const handleOpenViewModal = (payment) => {
        setSelectedPaymentTerm(payment);
        setIsViewOpen(true);
    };
    const handleCloseViewModal = () => {
        setIsViewOpen(false)
    };

    const fetchPaymentTerms = useCallback(async (page = currentPage, size = rowsPerPage, query = searchQuery) => {

        try {
            setIsLoading(true);
            const response = await fetch(`${API_BASE_URL}/api/setup/paymentterms/filtered-paymentterms?page=${page - 1}&size=${size}`, { credentials: 'include' });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setPayementTerms(Array.isArray(data.content) ? data.content : []);
            setFilteredPaymentTerms(Array.isArray(data.content) ? data.content : []);
            setCurrentPage(data.number + 1);
            setTotalPages(data.totalPages);
            setIsLoading(false);
        }
        catch (error) {
            console.error('Fetch error: ', error);
            setPayementTerms([]);
            setFilteredPaymentTerms([]);
            setIsLoading(false);
        }
    }, [currentPage, rowsPerPage]);



    const setNewComponentRight = () => {

        var currentIndex = 0;
        if (selectedPaymentTerm) {

            currentIndex = filteredPaymentTerms.indexOf(selectedPaymentTerm) || 0;

        }
        setSelectedPaymentTerm(filteredPaymentTerms[(currentIndex + 1) % filteredPaymentTerms.length]);
    }

    const setNewComponentLeft = () => {

        var currentIndex = 0;
        if (selectedPaymentTerm) {

            currentIndex = filteredPaymentTerms.indexOf(selectedPaymentTerm) || 0;

        }
        setSelectedPaymentTerm(filteredPaymentTerms[(currentIndex - 1 + filteredPaymentTerms.length) % filteredPaymentTerms.length]);
    }


    useEffect(() => {
        fetchPaymentTerms(currentPage, rowsPerPage, searchQuery);
    }, [fetchPaymentTerms, currentPage, rowsPerPage]);

    const handlePageChange = (page) => setCurrentPage(page);
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        if (e.target.value === '' && isSearched) {
            fetchPaymentTerms(1, rowsPerPage, "");
            setIsSearched(false);
        } else {
            const filtered = paymentTerms.filter((payment) =>
                payment.name.toLowerCase().includes(e.target.value.toLowerCase())


            );
            setFilteredPaymentTerms(filtered);
        }
    };

    const handleSearch = () => {
        setIsSearched(true);
        fetchPaymentTerms(1, rowsPerPage, searchQuery);
    };

    return (
        <div className="mx-auto pl-4 pr-4 h-screen w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Payment Terms List</h2>
                <div className="flex justify-end gap-4">
                    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                        <div className="px-3 py-2 text-gray-500 cursor-pointer">
                            <SearchIcon onClick={handleSearch} />
                        </div>
                        <input
                            type="text"
                            className="px-3 py-2 w-full outline-none"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            readOnly={isLoading}
                        />
                    </div>
                    <button
                        className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 flex text-sss-blue-sel font-bold
                        hover:bg-yellow-500 transition duration-300 ease-in-out"
                        onClick={handleOpenCreateModal}
                    >
                        Add +
                    </button>
                </div>
            </div>

            <div className="flex justify-center items-center">
                <ColorRing
                    visible={isLoading}
                    height="200"
                    width="200"
                    ariaLabel="color-ring-loading"
                    colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
                />
            </div>

            {!isLoading ? (
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            {PaymentTermsFields.map((field) => (
                                <th
                                    key={field.key}
                                    className="px-4 py-2 text-left font-bold text-sss-blue-sel"
                                >
                                    {field.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {filteredPaymentTerms.map((payment) => {
                            return (
                                <tr key={payment.id} className="border-t">
                                    {PaymentTermsFields.map((field) => {

                                        if (field.key === 'actions') {
                                            return (
                                                <td key={field.key} className="px-4 py-2">
                                                    <div className="flex space-x-2">
                                                        <button
                                                            className="text-sss-info mr-2"
                                                            onClick={() => handleOpenViewModal(payment)}
                                                        >
                                                            View
                                                        </button>
                                                    </div>
                                                </td>
                                            );
                                        }

                                        return (
                                            <td key={field.key} className="px-4 py-2">
                                                {field.map ? field.map[payment[field.key]] :
                                                    payment[field.key]}
                                            </td>
                                        )
                                    }


                                    )}
                                </tr>
                            )
                        }


                        )}
                    </tbody>
                </table>
            ) : null}

            <ViewPaymentTermsModal
                open={isViewOpen}
                handleClose={handleCloseViewModal}
                paymentTerm={selectedPaymentTerm}
                setPaymentTerm={setSelectedPaymentTerm}

                setNext={setNewComponentRight}
                setPrev={setNewComponentLeft}

                allPayments={filteredPaymentTerms}
                updateAll={setFilteredPaymentTerms}
            />


            <AddPaymentTermsModal
                open={isCreateOpen}
                handleClose={handleCloseCreateModal}
            />


            <PaginationControls
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </div>
    );
};


PayementTermsList.propTypes = {
    paymentTerms: PropTypes.arrayOf(PropTypes.object),
    setPaymentTerms: PropTypes.func,
};


export default PayementTermsList;
